module.exports = __webpack_public_path__ + "img/26a)Auswärtiges Amt.jpg";